module.exports = __webpack_public_path__ + "static/4-1-6169cfd564656a091344f8ad778ad7d9.gif";